var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingSessionsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8 6.21875 6.20312 8 4 8C1.78125 8 0 6.21875 0 4C0 1.79688 1.78125 0 4 0C6.20312 0 8 1.79688 8 4Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingSessionsCircle);
export default __webpack_public_path__ + "static/media/UpcomingSessionsCircle.bac37c8d5a10453d2725339c7de24779.svg";
export { ForwardRef as ReactComponent };